import { Trans } from '@lingui/react';
import { Alert } from '@startuptools/ui/Alert';
import { Box } from '@startuptools/ui/Box';
import { Stack } from '@startuptools/ui/Stack';
import { Accordion } from '@startuptools/ui/Accordion';
import { AccordionSummary } from '@startuptools/ui/AccordionSummary';
import { AccordionDetails } from '@startuptools/ui/AccordionDetails';
import { AccordionGroup } from '@startuptools/ui/AccordionGroup';
import { orderBy } from 'lodash-es';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { useShareTransactionGroupsSuspenseQuery } from './Transactions.graphql';
import { TransactionsTable } from './components/TransactionsTable';
import { Header } from './Header';

export const Transactions = ({
  showNewTransactionButton = false,
  showShareRanges,
  navigateToStg,
}: {
  showNewTransactionButton?: boolean;
  showShareRanges: boolean;
  navigateToStg: (stgId: string) => void;
}) => {
  const companyId = useCompanyId();
  const { data, error } = useShareTransactionGroupsSuspenseQuery({
    variables: { companyId },
    fetchPolicy: 'cache-and-network',
  });
  const { shareTransactionGroups } = data;

  return (
    <Stack gap={2}>
      {!data.shareState.isValid && (
        <Alert variant="outlined" color="danger">
          <Trans id="The share register is in an unexpected state, but your data is safe. Contact customer support for more info." />
        </Alert>
      )}
      <Box>
        {error ? (
          <Alert variant="outlined" color="danger">
            <Trans id="An error occurred. Please refresh the page. If the error persists, contact our customer support" />
          </Alert>
        ) : (
          Boolean(shareTransactionGroups.length) && (
            <AccordionGroup variant="outlined">
              {orderBy(
                shareTransactionGroups,
                [stg => stg.transactionDate, stg => stg.sortOrder],
                ['desc', 'desc'],
              ).map(stg => (
                <Accordion key={stg.id}>
                  <AccordionSummary>
                    <Header stg={stg} />
                  </AccordionSummary>
                  <AccordionDetails>
                    <TransactionsTable
                      transactionGroup={stg}
                      showNewTransactionButton={showNewTransactionButton}
                      navigateToStg={() => navigateToStg(stg.id)}
                      forbiddenToDeleteStg={false}
                      showShareRange={showShareRanges}
                    />
                  </AccordionDetails>
                </Accordion>
              ))}
            </AccordionGroup>
          )
        )}
      </Box>
    </Stack>
  );
};
